import React, { useState, useEffect } from "react";
import Navbar from "../../../Shared/Navbar/Navbar";
import axios from "axios";
import DataTable from "../../../Layout/Table/TableLayout";
import { baseURL } from "../../../Apiservices/Api";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaEdit, FaTrash, FaCopy } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Templates = () => {
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [templatesList, setTemplatesList] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [activeTab, setActiveTab] = useState("lead"); // ✅ TAB STATE

  useEffect(() => {
    fetchTemplates();
  }, []);

  // ✅ Fetch Templates
  const fetchTemplates = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/templates`);
      setTemplatesList(response.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  // ✅ Add / Update
  const handleAddOrUpdate = async () => {
    if (title.trim() === "" || body.trim() === "") return;

    try {
      if (editingId) {
        await axios.put(`${baseURL}/api/templates/${editingId}`, {
          title,
          body,
        });
      } else {
        await axios.post(`${baseURL}/api/templates`, {
          title,
          body,
        });
      }

      fetchTemplates();
      setTitle("");
      setBody("");
      setEditingId(null);
    } catch (error) {
      console.error("Error saving template:", error);
    }
  };

  const handleEdit = (template) => {
    setTitle(template.title);
    setBody(template.body);
    setEditingId(template.id);
  };

  const handleCancel = () => {
    setTitle("");
    setBody("");
    setEditingId(null);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseURL}/api/templates/${id}`);
      fetchTemplates();
    } catch (error) {
      console.error("Error deleting template:", error);
    }
  };

  const handleCopy = (template) => {
    const formatted = `*${template.title}*\n\n${template.body}`;
    navigator.clipboard.writeText(formatted);
    alert("Copied to clipboard!");
  };

  // ✅ TABLE
  const columns = [
    { Header: "S.No", accessor: "serial" },
    { Header: "Title", accessor: "title" },
    { Header: "Body", accessor: "body" },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <div className="btn-group">
          <FaCopy
            style={{ color: "#28a745", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleCopy(row.original)}
          />
          <FaEdit
            style={{ color: "#ff9966", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(row.original)}
          />
          <FaTrash
            style={{ color: "#dc3545", cursor: "pointer" }}
            onClick={() => handleDelete(row.original.id)}
          />
        </div>
      ),
    },
  ];

  const data = templatesList.map((t, index) => ({
    serial: index + 1,
    id: t.id,
    title: t.title,
    body: t.body,
  }));

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />

      <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>

        {/* 🔥 TABS (SAME AS LEAD STATUS) */}
        <div className="payments-tabs">
          <button
            className={activeTab === "lead" ? "active" : ""}
            onClick={() => setActiveTab("lead")}
          >
            Lead WhatsApp Templates
          </button>

          <button
            className={activeTab === "opportunity" ? "active" : ""}
            onClick={() => {
              setActiveTab("opportunity");
              navigate("/a-opp-whatsapp-templates"); // 🔁 change route if needed
            }}
          >
            Opportunity WhatsApp Templates
          </button>
        </div>

        <h1> Lead WhatsApp Templates</h1>

        {/* FORM */}
        <div className="container mt-3">
          <div className="row">

            {/* LEFT */}
            <div className="col-md-6">
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Example: Hi {name}"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />

              <textarea
                className="form-control mb-2"
                rows="5"
                placeholder="Example: Hi {name}, we sent details to {email}"
                value={body}
                onChange={(e) => setBody(e.target.value)}
              />

              <button
                className="btn btn-success px-4 me-2"
                onClick={handleAddOrUpdate}
              >
                {editingId ? "Update" : "Add"}
              </button>

              {editingId && (
                <button
                  className="btn btn-secondary px-4"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              )}
            </div>

            {/* RIGHT HELP BOX */}
            <div className="col-md-6">
              <div className="alert alert-info" style={{ fontSize: "14px" }}>
                <strong>How to use dynamic fields:</strong>
                <br />
                <code>{"{name}"}</code>, <code>{"{email}"}</code>, <code>{"{phone}"}</code>,{" "}
                <code>{"{leadid}"}</code>, <code>{"{destination}"}</code>, <code>{"{city}"}</code>

                <hr />

                <strong>Example Template:</strong>
                <br />
                Hi {"{name}"}, we have sent the quotation to {"{email}"}.

                <br /><br />

                <strong>Output:</strong>
                <br />
                Hi Ravi, we have sent the quotation to ravi@example.com
              </div>
            </div>

          </div>
        </div>

        {/* TABLE */}
        <div className="mt-4">
          <DataTable columns={columns} data={data} />
        </div>

      </div>
    </div>
  );
};

export default Templates;